var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.experiment)?_c('div',{class:'template-' + _vm.experiment.template_id},[(_vm.experiment.status === '1')?_c('p',[_vm._v("DRAFT")]):_vm._e(),_c('screen',{attrs:{"screen":_vm.screens[_vm.progress]},on:{"hook:mounted":function($event){return _vm.checkOrientation()}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }